module.exports = __webpack_public_path__ + "static/image001-fd14c490881a32b62f0b75e7484ecd2e.jpg";